import React, { SVGProps, useEffect, useState } from "react";
import Logo from "../../assests/OC_Main_Logo.png";
import "./Sidebar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { reactIcons } from "../../icons/reactIcons";
import {
  dtsSidebarMenuItems,
  plcSidebarMenuItems,
  sidebarMenuItems,
  superAdminSidebaeMenuItems,
  thirtyForThirtyMenuItem,
} from "../../data/data";
import { useSelector } from "react-redux";
import { RootState } from "../../store";

interface sidebarprops {
  // setIsAuthenticated: (isAuthenticated: string) => void;
}

export interface sidebarMenuItemsProps {
  id: number;
  title: string;
  icon: React.FC<SVGProps<SVGSVGElement>>;
  path: string;
}

export interface sidebarMenu {
  id: number;
  parent: string;
  children: sidebarMenuItemsProps[];
}

const Sidebar: React.FC<sidebarprops> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activePath = location.pathname;
  const { featureName } = useSelector((state: RootState) => state?.AuthCard);

  const [openId, setOpenId] = useState<number | null>(1);

  const [sidebarData, setSideBarData] = useState<sidebarMenu[]>([]);
  const [path, setPath] = React.useState<string>(
    featureName === "super_admin"
      ? "/super-admin/admins"
      : featureName === "oc_all_in"
        ? "/oc-all-in/term-data"
        : featureName === "plc"
          ? "/plc/events"
          : "",
  );

  const toggleAccordion = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  //using the following state to show the loaderBtn
  const [loaderBtn, setLoaderBtn] = useState(false);

  //using the following useEffect to set the sidebarMenuItems based on the featureName
  useEffect(() => {
    let sidebarData = activePath.startsWith("/oc-all-in")
      ? sidebarMenuItems
      : activePath.startsWith("/super-admin")
        ? superAdminSidebaeMenuItems
        : activePath?.startsWith("/plc")
          ? plcSidebarMenuItems
          : activePath.startsWith("/dts")
            ? dtsSidebarMenuItems
            : activePath.startsWith("/thirty-for-thirty")
              ? thirtyForThirtyMenuItem
              : [];
    setSideBarData(sidebarData);
  }, [activePath]);

  //using the following useEffect to open the active accordian
  useEffect(() => {
    const activeParent = sidebarData.find((parent) =>
      parent.children.some((child) => activePath.startsWith(child.path)),
    );
    if (activeParent) {
      setOpenId(activeParent.id);
    }
  }, [activePath, sidebarData]);

  const handlePath = (path: string) => {
    navigate(path);
    setPath(path);
  };

  return (
    <nav className="sidebar" aria-label="Super Admin Sidebar">
      <div className="sidebar-logo-container">
        <img src={Logo} alt="loading..." className="oc-main-logo" />
      </div>
      {sidebarData.map((parent) => {
        const isOpen = openId === parent.id;
        return (
          <div key={parent.id} className="sidebar-accordion-section">
            {/* Accordion Header */}
            {parent?.parent !== "" && (
              <button
                className={`${parent?.parent === "" ? "" : "sidebar-accordion-header"}`}
                onClick={() => toggleAccordion(parent.id)}
                aria-expanded={isOpen}
                aria-controls={`section-${parent.id}`}
                id={`accordion-${parent.id}`}
              >
                {parent.parent}
                <span className="accordion-icon">
                  {isOpen ? (
                    <reactIcons.arrowUp className="sidebar-menu-icon" />
                  ) : (
                    <reactIcons.arrowDown className="sidebar-menu-icon" />
                  )}
                </span>
              </button>
            )}

            {/* Accordion Panel */}
            <div
              id={`section-${parent.id}`}
              role="region"
              aria-labelledby={`accordion-${parent.id}`}
              hidden={!isOpen}
              className="sidebar-accordion-panel"
            >
              {parent.children.map((item) => (
                <div
                  key={item.id}
                  className="sidebar-menu-container"
                  onClick={() => handlePath(item.path)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) =>
                    (e.key === "Enter" || e.key === " ") &&
                    handlePath(item.path)
                  }
                >
                  <div
                    className={`${
                      activePath.startsWith(item.path) ? "sidebar-barline" : ""
                    }`}
                  ></div>

                  <div
                    className={`${
                      activePath.startsWith(item?.path) ? "active" : "inActive"
                    }`}
                  >
                    <item.icon
                      className={`${item?.title === "Reward Type" ? "sidebar-rewardIcon " : ""}${
                        activePath.startsWith(item.path)
                          ? "sidebar-active-icon"
                          : "sidebar-inActive-icon"
                      }`}
                    />
                    <span className="sidebar-title">{item.title}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </nav>
  );
};

export default Sidebar;
